export { Color, RGB, DEFAULT_COLORS } from "./Color";

export { default as hexToRgb } from "./hexToRgb";

export { default as hslToRgb } from "./hslToRgb";

export { default as rgbToHex } from "./rgbToHex";

export { default as rgbToHsl } from "./rgbToHsl";

export * from "./interpolate";
//# sourceMappingURL=index.js.map